import { useState, useEffect } from "react";

const LOGO_URL = "https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/0245c007cf03e632cb0ef6dc8c6831b5.png";
const WHATSAPP_URL = "https://wa.me/5547996077227?text=Olá,%20gostaria%20de%20falar%20com%20um%20advogado.";

const navLinks = [
  { label: "Início", href: "#hero" },
  { label: "Sobre", href: "#sobre" },
  { label: "Áreas", href: "#areas" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Contato", href: "#contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? "bg-white md:bg-[#0A2472] shadow-md py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNavClick("#hero"); }}
          className="flex items-center cursor-pointer"
        >
          <img
            src={LOGO_URL}
            alt="Quelen Manske Advocacia"
            className="h-[92px] w-auto object-contain"
          />
        </a>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-[#0A2472] md:text-white hover:text-[#C8A63A] md:hover:text-[#E6D18A]"
                  : "text-white/90 hover:text-[#E6D18A]"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? "text-[#0A2472]" : "text-white"}`}
        >
          <i className={`text-2xl ${menuOpen ? "ri-close-line" : "ri-menu-3-line"}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden transition-all duration-300 overflow-hidden ${
          menuOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
        } bg-white shadow-lg`}
      >
        <div className="px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
              className="text-[#0A2472] font-medium text-sm py-2 border-b border-gray-100 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </div>
      </div>
    </header>
  );
}
